import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { AreaNodeEdge, AreaNodeConnection } from '../../../schema';
import { areaDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class AreaDropdownSelect extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<AreaNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string, selectedTown: string }, { data: { allAreas: AreaNodeConnection } }>(
        API_URL,
        { name, selectedTown: this.props.selectedTown },
        areaDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allAreas.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      this.props.selectedTown && <AutoCompleteAsync
        {...this.props}
        mode='single'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<AreaNodeEdge>, 'data'> {
  selectedTown: string;
  mode: 'single';
  value: AreaNodeEdge;
  onChange: (value: AreaNodeEdge) => void;
}
